import { useEffect, useState } from 'react';

export const useIsMobile = (mediaQuery = '(max-width: 768px)') => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.matchMedia(mediaQuery).matches : false
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const mql = window.matchMedia(mediaQuery);
    const handleChange = () => setIsMobile(mql.matches);

    // Ініціалізуємо і підписуємось
    setIsMobile(mql.matches);
    mql.addEventListener('change', handleChange);

    return () => {
      mql.removeEventListener('change', handleChange);
    };
  }, [mediaQuery]);

  return isMobile;
};
